import { Injectable } from '@angular/core';
import { DatiqCellHeaderSortBy, IDatiqCellHeaderSort } from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqCellHeaderService {
    constructor() {}

    toggleSortBy(settings: IDatiqCellHeaderSort): IDatiqCellHeaderSort {
        const sortBy: DatiqCellHeaderSortBy = this.isNone(settings)
            ? DatiqCellHeaderSortBy.DEC
            : this.isAscending(settings)
            ? DatiqCellHeaderSortBy.DEC
            : DatiqCellHeaderSortBy.ASC;

        return {
            ...settings,
            sortBy,
        };
    }

    isAscending(settings: IDatiqCellHeaderSort): boolean {
        return settings?.sortBy === DatiqCellHeaderSortBy.ASC;
    }
    isNone(settings: IDatiqCellHeaderSort): boolean {
        return !this.isAscending(settings) && !this.isDescending(settings);
    }
    isDescending(settings: IDatiqCellHeaderSort): boolean {
        return settings?.sortBy === DatiqCellHeaderSortBy.DEC;
    }
}
